module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/move-free-fa121245017fff009e5b781109ce40f9.svg";